import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from './../../services/contact.service';
import { EncrDecrService } from './../../services/encr-decr.service';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { environment } from '../../../environments/environment.prod';
import { saveAs } from 'file-saver';

let obj: CustomerListComponent;
import * as Papa from 'papaparse';
import { heLocale } from 'ngx-bootstrap';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})

export class CustomerListComponent implements OnInit {

  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  listdata: any = ["Company Name", "Contact Name", "Contact Phone", "Extension", "Mobile", "Contact Email", "Cc Email", "Credit limit", "Terms", "Mark Up", "NOA on Every Invoice", "Tax Rate", "Status", "Assigned to Factoring Company", "Don't Submit To Factoring Company-Non-Factored Account", "Main Address 1", "Main Address 2", "Main Country", "Main City", "Main State", "Main Zip", "Billing Address 1", "Billing Address 2", "Billing Country", "Billing City", "Billing State", "Billing Zip", "Billing Email"];

  csvDatavalue: any = {};
  public data: Object;
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  modelInfo: any = {};
  model: any = {};
  delete_contact_id: any;
  cust_status: any = '';
  customer_id: number = 0;
  statusValue: string = 'all';
  CSV_Datalist: FormGroup;
  submitted = false;
  csvRecords: any = [];
  loaderMode: any = true;
  dataList: any[];
  modalRef: BsModalRef;
  display: any = 'none';
  show_CSV: boolean = false;
  show_ListData: boolean = true;
  csvCellName: any = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF'];

  show_browser_file: any = true;

  select_field_array: any;

  AllClassData = [];

  customerCsvPath: any = '';

  constructor(
    private http: HttpClient,
    private _contact: ContactService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private modalService: BsModalService,
    public fb: FormBuilder,
    private _activatedroute: ActivatedRoute,) { }
  oppoSuitsForm = this.fb.group({
    name: ['']
  })

  dtOptions: DataTables.Settings = {};
  dtOptionsList: DataTables.Settings = {};

  ngOnInit() {
    this.dtOptions = {
      // scrollY: '500',
      scrollX: true,
    };
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this._activatedroute.params.subscribe(params => {
      this.statusValue = params['status'];
    });
    this.modelInfo = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: this.statusValue,
    };
    this.data = [];
    this.loaderMode = true;
    this.dtOptionsList = {
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [25, 50, 100, 150],
      columnDefs: [{
        'targets': [0, 12], // column index (start from 0)
        'orderable': false, // set orderable false for selected columns
      }],
      order: [[11, 'desc']],
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.minNumber = dataTablesParameters.start + 1;
        dataTablesParameters.maxNumber = dataTablesParameters.start + dataTablesParameters.length;

        dataTablesParameters.APIKEY = this.APIKEY;
        dataTablesParameters.user_id = this.user_id;
        dataTablesParameters.company_id = this.company_id;
        dataTablesParameters.status = this.statusValue;

        this.http
          .post<DataTablesResponse>(
            environment.api + "/Contact/getContactListAjax",
            dataTablesParameters
          )
          .subscribe((resp: any) => {

            this.loaderMode = false;
            if (resp.status == true) {
              this.data = resp.data;
            }

            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'customer.customer_id' }, { data: 'customer.customer_no' }, { data: 'customer.contact_name' }, { data: 'customer.company_name' }, { data: 'customer.phone_number' }, { data: 'customer.billing_email' }, { data: 'addresses.address1' }, { data: 'customer.creditlimit' }, { data: 'customer.terms' }, { data: 'customer.assign_fact' }, { data: 'customer.noa' }, { data: 'customer.created_at' }, { data: 'action' }]
    };

    // obj = this;
    this.createform();
  }

  createform() {
    let arr = [];
    let count = 1;
    for (let i = 0; i < this.csvRecords.length; i++) {
      // console.log(this.csvRecords[i])  
      arr.push(this.BuildFormDynamic(this.csvRecords[i]))
      count++;
    }
    this.loaderMode = false;
    this.CSV_Datalist = this.fb.group({
      ClassDetails: this.fb.array(arr)
    })
  }

  BuildFormDynamic(product): FormGroup {
    return this.fb.group({
      company_name: [product.company_name],
      Contact_Name: [product.Contact_Name],
      Contact_Phone: [product.Contact_Phone],
      Extension: [product.Extension],
      Mobile: [product.Mobile],
      Contact_Email: [product.Contact_Email],
      Cc_Email: [product.Cc_Email],
      Credit_limit: [product.Credit_limit],
      Terms: [product.Terms],
      Mark_up: [product.Mark_up],
      noa: [product.noa],
      Tax_rate: [product.Tax_rate],

      Status: [product.Status],
      assign_fact: [product.assign_fact],
      assign_nostamp: [product.assign_nostamp],
      no_assign: [product.no_assign],
      Main_Address_1: [product.Main_Address_1],
      Main_Address_2: [product.Main_Address_2],
      Main_Country: [product.Main_Country],
      Main_City: [product.Main_City],
      Main_State: [product.Main_State],
      Main_Zip: [product.Main_Zip],
      Address_1: [product.Address_1],
      Address_2: [product.Address_2],
      Country: [product.Country],
      City: [product.City],
      State: [product.State],
      Zip: [product.Zip],
      Billing_Email: [product.Billing_Email]
    })
  }

  callingFunction() {
    // console.log(this.CSV_Datalist.value);
  }

  onChangeEvent(ev) {
    const status = ev.target.value;
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigateByUrl('/customer/customer-list/' + status);
    });
  }

  set_delete_id(cid) {
    this.delete_contact_id = cid;
  }

  delete_user() {
    const data = {
      customer_id: this.delete_contact_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
    }
    this._contact.deleteContact(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/customer/customer-list/active');
          });
        },
        err => console.log(err)
      );
  }

  set_active_id(customer_id, status) {
    this.customer_id = customer_id;
    this.cust_status = status;
  }

  active_customer() {
    const data = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: this.cust_status,
      customer_id: this.customer_id,
      company_id: this.company_id,
    }

    this._contact.activeContact(data)
      .subscribe(
        res => {
          //  this.ngOnInit();
          // console.log(res);
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/customer/customer-list/active');
          });
        },
        err => console.log(err)
      );
  }

  redirectedinto(customer_id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), customer_id);
    this._router.navigate(["/customer/edit-customer/" + encrypted]);
  }

  isCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };

  arrayOne(n: number): any[] {
    return Array(n);
  }

  ///////////////////////////////////CSV Portion///////////////////////////////////////////////////////////////
  openModalBtn() {
    this.display = 'block';
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  onCloseHandled() {
    this.display = 'none';
  }

  redirectPage(url) {
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigate([url]);
    });
  }

  recodes: any;
  fieldrecodes: any;

  csvFileMode: any = true;
  newCSV: any;
  matchnewData: any;
  title = 'app';
  CSVRecord: any;
  @ViewChild('fileImportInput') fileImportInput: any;
  files: any;
  fileevent: any;
  emailcontentdiv: boolean = false;

  fileChangeListener($event: any): void {
    let text = [];
    this.files = $event.srcElement.files;
    this.fileevent = $event;

    if (this.isCSVFile(this.files[0])) {
      let reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let csvData = reader.result;
        let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        let headersRow = this.getHeaderArray(csvRecordsArray);
        this.recodes = headersRow;

        if (headersRow[0] == "Company Name" && headersRow[1] == "Contact Name" && headersRow[2] == "Contact Phone" && headersRow[3] == "Extension" && headersRow[4] == "Mobile" && headersRow[5] == "Contact Email" && headersRow[6] == "Cc Email" && headersRow[7] == "Credit limit" && headersRow[8] == "Terms" && headersRow[9] == "Mark Up" && headersRow[10] == "NOA on Every Invoice" && headersRow[11] == "Tax Rate" && headersRow[12] == "Status" && headersRow[13] == "Assigned to Factoring Company" && headersRow[14] == "Don't Submit To Factoring Company-Non-Factored Account" && headersRow[15] == "Main Address 1" && headersRow[16] == "Main Address 2" && headersRow[17] == "Main Country" && headersRow[18] == "Main City" && headersRow[19] == "Main State" && headersRow[20] == "Main Zip" && headersRow[21] == "Billing Address 1" && headersRow[22] == "Billing Address 2" && headersRow[23] == "Billing Country" && headersRow[24] == "Billing City" && headersRow[25] == "Billing State" && headersRow[26] == "Billing Zip" && headersRow[27] == "Billing Email") {
          this.display = 'block';
          this.show_browser_file = false;
        }
        else {
          alert('Import file format is wrong, click sample file for demo csv file');
          $('#txtFileUpload').val('');
        }
      };
      reader.onerror = function () {
        console.log('error is occured while reading file!');
      };
    } else {
      $("#txtFileUpload").val('');
      this.toastr.error('Invaild File Format. Only Csv File Are Allowed!');
    }
  }

  uploadFile($files: any) {
    let returnArry = [];
    if (this.isCSVFile($files[0])) {

      let reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let csvData = reader.result;
        //console.log('csvData onload ' , csvData) ;

        let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        //console.log('csvRecordsArray ' , csvRecordsArray) ;

        let headersRow = this.getHeaderArray(csvRecordsArray);
        this.fieldrecodes = headersRow;

        this.csvRecords = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);

      };
      reader.onerror = function () {
        console.log('error is occured while reading file!');
      };
    }
    else {
      $("#txtFileUpload").val('');
      this.toastr.error('Invaild File Format. Only Csv File Are Allowed!');
    }
  }

  //GET CSV FILE HEADER COLUMNS
  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let dataArr = [];

    /*const input_line = '"2C95699FFC68","201 S BOULEVARDRICHMOND, VA 23220","8299600062754882","2018-09-23"'
    let my_split = input_line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/) ;
    console.log('my_split' , my_split) ;
    console.log('my_split' , my_split[1].replace(/\"/g, '')) ;*/

    for (let i = 1; i < csvRecordsArray.length; i++) {

      //let data = (<string>csvRecordsArray[i]).split(',');
      //changed this split by deepak 10Feb2022 
      let data = (<string>csvRecordsArray[i]).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

      if (data.length == headerLength) {
        let csvRecord: any = [];

        var select_field_array = this.select_field_array;
        var indexa = select_field_array.indexOf("Company Name");
        //console.log('indexa' , indexa);
        //console.log('data[select_field_array.indexOf("Company Name")]' , data[select_field_array.indexOf("Company Name")]);
        //console.log('data[select_field_array.indexOf("Company Name")]' , data[select_field_array.indexOf("Company Name")].replace(/\"/g, ''));
        csvRecord.company_name = data[select_field_array.indexOf("Company Name")].replace(/\"/g, '');
        csvRecord.Contact_Name = data[select_field_array.indexOf("Contact Name")].replace(/\"/g, '');
        csvRecord.Contact_Phone = data[select_field_array.indexOf("Contact Phone")].replace(/\"/g, '');
        csvRecord.Extension = data[select_field_array.indexOf("Extension")];
        csvRecord.Mobile = data[select_field_array.indexOf("Mobile")].replace(/\"/g, '');
        csvRecord.Contact_Email = data[select_field_array.indexOf("Contact Email")].replace(/\"/g, '');
        csvRecord.Cc_Email = data[select_field_array.indexOf("Cc Email")].replace(/\"/g, '');
        csvRecord.Credit_limit = data[select_field_array.indexOf("Credit limit")];

        var Terms = data[select_field_array.indexOf("Terms")].split(" ")
        csvRecord.Terms = Terms[1];
        csvRecord.Mark_up = data[select_field_array.indexOf("Mark Up")].replace(/\"/g, '');
        csvRecord.noa = data[select_field_array.indexOf("NOA on Every Invoice")].replace(/\"/g, '');
        csvRecord.Tax_rate = data[select_field_array.indexOf("Tax Rate")].replace(/\"/g, '');
        var status = select_field_array.indexOf("Status");
        if (data[status] == 'Active' || data[status] == 'active') { csvRecord.Status = 'active'; } else { csvRecord.Status = 'inactive'; }

        csvRecord.assign_fact = data[select_field_array.indexOf("Assigned to Factoring Company")];
        // csvRecord.assign_nostamp = data[select_field_array.indexOf("Assigned to Factoring Company - Notification Already On My Invoice")];
        csvRecord.no_assign = data[select_field_array.indexOf("Don't Submit To Factoring Company-Non-Factored Account")];
        csvRecord.Main_Address_1 = data[select_field_array.indexOf("Main Address 1")].replace(/\"/g, '');
        csvRecord.Main_Address_2 = data[select_field_array.indexOf("Main Address 2")].replace(/\"/g, '');
        csvRecord.Main_Country = data[select_field_array.indexOf("Main Country")].replace(/\"/g, '');
        csvRecord.Main_City = data[select_field_array.indexOf("Main City")].replace(/\"/g, '');
        csvRecord.Main_State = data[select_field_array.indexOf("Main State")].replace(/\"/g, '');
        csvRecord.Main_Zip = data[select_field_array.indexOf("Main Zip")].replace(/\"/g, '');
        csvRecord.Address_1 = data[select_field_array.indexOf("Billing Address 1")].replace(/\"/g, '');
        csvRecord.Address_2 = data[select_field_array.indexOf("Billing Address 2")].replace(/\"/g, '');
        csvRecord.Country = data[select_field_array.indexOf("Billing Country")].replace(/\"/g, '');
        csvRecord.City = data[select_field_array.indexOf("Billing City")].replace(/\"/g, '');
        csvRecord.State = data[select_field_array.indexOf("Billing State")].replace(/\"/g, '');
        csvRecord.Zip = data[select_field_array.indexOf("Billing Zip")].replace(/\"/g, '');
        csvRecord.Billing_Email = data[select_field_array.indexOf("Billing Email")];

        dataArr.push(csvRecord);
      }
    }
    return dataArr;
  }

  csvDataList: any;
  onSubmit() {
    this.loaderMode = true;
    const select_fact_array = [];
    $(".checkImageAllOpn").each(function () {
      //console.log($(this).val());
      select_fact_array.push($(this).val());
    });

    if (!this.hasDuplicates(select_fact_array)) {
      this.uploadFile(this.files);
      setTimeout(() => {
        this.createform();
      }, 500);

      // console.log(select_fact_array);

      this.onCloseHandled();
      this.select_field_array = select_fact_array;
      this.csvDataList = select_fact_array;
      if (this.csvDataList != '') {
        this.show_CSV = true;
        this.show_ListData = false;

      }
    }
    else {
      alert('CSV column and database mapping is incorrect');
      this.loaderMode = false;
      return false;
    }

  }

  hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }



  saveImportData() {
    const data = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      importDat: this.CSV_Datalist.value,

    }

    this.loaderMode = true;
    this._contact.saveImportContact(data)
      .subscribe(
        res => {
          this.loaderMode = false;
          //console.log(res);
          this.ngOnInit();
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/customer/customer-list/active');
          });
        },
        err => {
          this.loaderMode = false;
          console.log(err)
        }
      );
  }


  exportCustomerCsv() {
    this.loaderMode = true;
    const dataModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: this.statusValue,
    }

    // console.log('dataModal ', dataModal);

    //get mobile folder list 
    this._contact.exportCustomerCsv(dataModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          this.customerCsvPath = res.url;
          this.forceDownload(this.customerCsvPath);
        },
      );
  }

  forceDownload(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    //console.log('CSV fileName' , fileName) ;
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )

  }


}